import { render } from "./Container.vue?vue&type=template&id=51b8a1ec&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"

import "./Container.vue?vue&type=style&index=0&id=51b8a1ec&lang=scss&scoped=true"

import exportComponent from "/home/knavarro/Proyectos/IGP/programas-investigacion/cts-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b8a1ec"]])

export default __exports__